import { render, staticRenderFns } from "./side-menu-item.vue?vue&type=template&id=43362c24"
import script from "./side-menu-item.vue?vue&type=script&lang=js"
export * from "./side-menu-item.vue?vue&type=script&lang=js"
import style0 from "./side-menu-item.vue?vue&type=style&index=0&id=43362c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports